import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AppShell } from "@/components/layout/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import SiteManagerPage from "@/pages/SiteManagerPage";
import CreateSitePage from "@/pages/CreateSitePage";
import SiteDetailPage from "@/pages/SiteDetailPage";
import PreviewPage from "@/pages/PreviewPage";
import SEODashboardPage from "@/pages/SEODashboardPage";
import BulkImportPage from "@/pages/BulkImportPage";
import SchedulerPage from "@/pages/SchedulerPage";
import ReviewQueuePage from "@/pages/ReviewQueuePage";
import DeploymentPage from "@/pages/DeploymentPage";
import MonitoringPage from "@/pages/MonitoringPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import RevenuePage from "@/pages/RevenuePage";
import LaunchChecklistPage from "@/pages/LaunchChecklistPage";
import ServersPage from "@/pages/ServersPage";
import EmailOpsPage from "@/pages/EmailOpsPage";
import ProductionHealthPage from "@/pages/ProductionHealthPage";
import V3ContentPage from "@/pages/V3ContentPage";
import SitemapHealthPage from "@/pages/SitemapHealthPage";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("trafficos_token");
  if (!token) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          {/* Preview - full page, no shell */}
          <Route path="/preview/:siteId" element={<PreviewPage />} />
          
          {/* Protected routes */}
          <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/sites" element={<ProtectedRoute><SiteManagerPage /></ProtectedRoute>} />
          <Route path="/sites/new" element={<ProtectedRoute><CreateSitePage /></ProtectedRoute>} />
          <Route path="/sites/bulk" element={<ProtectedRoute><BulkImportPage /></ProtectedRoute>} />
          <Route path="/sites/:siteId/detail" element={<ProtectedRoute><SiteDetailPage /></ProtectedRoute>} />
          <Route path="/seo" element={<ProtectedRoute><SEODashboardPage /></ProtectedRoute>} />
          <Route path="/scheduler" element={<ProtectedRoute><SchedulerPage /></ProtectedRoute>} />
          <Route path="/review" element={<ProtectedRoute><ReviewQueuePage /></ProtectedRoute>} />
          <Route path="/deploy" element={<ProtectedRoute><DeploymentPage /></ProtectedRoute>} />
          <Route path="/monitoring" element={<ProtectedRoute><MonitoringPage /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
          <Route path="/revenue" element={<ProtectedRoute><RevenuePage /></ProtectedRoute>} />
          <Route path="/launch" element={<ProtectedRoute><LaunchChecklistPage /></ProtectedRoute>} />
          <Route path="/servers" element={<ProtectedRoute><ServersPage /></ProtectedRoute>} />
          <Route path="/email-ops" element={<ProtectedRoute><EmailOpsPage /></ProtectedRoute>} />
          <Route path="/production-health" element={<ProtectedRoute><ProductionHealthPage /></ProtectedRoute>} />
          <Route path="/v3-content" element={<ProtectedRoute><V3ContentPage /></ProtectedRoute>} />
          <Route path="/sitemap-health" element={<ProtectedRoute><SitemapHealthPage /></ProtectedRoute>} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
